const RESPONSE_DELAY = {
  RESPONSE_DELAY_FORM_TITLE: 'Create New Operation',
  RESPONSE_DELAY_LIST_TITLE: ' Response Delay Operations',
  RESPONSE_DELAY_FORM_BTN: 'Create New Operation',
  RESPONSE_DELAY_LIST_BTN: 'List of Operations',
  ALL_DEPARTMENTS: 'Apply to All Departments',
  ONE_DEPARTMENT: 'Apply to One Department',
  ALL_DEPARTMENTS_LABEL: 'Type of Operations',
  DEPARTMENT_SELECTION_LABEL: 'Select Department',
  RESPONSE_DELAY_TIME_INPUT_LABEL: 'Waiting Time',
  RESPONSE_DELAY_TIME_INPUT_LABEL_SECOND: 'Second',
  RESPONSE_DELAY_TIME_INPUT_LABEL_MINUTE: 'Minute',
  RESPONSE_DELAY_TIME_INPUT_PLACEHOLDER_SECOND: 'Second',
  RESPONSE_DELAY_TIME_INPUT_PLACEHOLDER_MINUTE: 'Minute',
  BEFORE_RESPONSE_DELAY_EDITOR_LABEL: 'Message Text Before Response',
  AFTER_RESPONSE_DELAY_EDITOR_LABEL: 'Message Text After Response',
  RESPONSE_DELAY_EDITOR_PLACEHOLDER: 'Your Message',
  FORM_GENERATOR_FIELD_LABEL: 'Field Number ',
  FORM_GENERATOR_LABEL: 'Specify the field label',
  FORM_GENERATOR_PLACEHOLDER: 'Enter the field name!',
  FORM_GENERATOR_TYPE: 'Determine the field type',
  FORM_GENERATOR_BUTTON: 'Add Form',
  RESPONSE_DELAY_DEFAULT_PREVIEW:
    'Welcome to our website, we are at your service🖐',
  RESPONSE_DELAY_INCOMING: 'Awaiting Response',
  RESPONSE_DELAY_IN_CONVERSATION: 'In Conversation',
  RESPONSE_DELAY_TYPE_TITLE: 'Send in Conversations',
  RESPONSE_DELAY_TABLE_TITLE_1: 'Title',
  RESPONSE_DELAY_TABLE_TITLE_2: 'Status',
  RESPONSE_DELAY_TABLE_TITLE_3: 'Form',
  RESPONSE_DELAY_TABLE_TITLE_4: 'All Departments',
  RESPONSE_DELAY_TABLE_TITLE_5: 'Edit and Delete',
  RESPONSE_DELAY_LIST_EMPTY: 'No operations defined!',
  RESPONSE_DELAY_CONDITION_ACTIVE: 'Active',
  RESPONSE_DELAY_CONDITION_INACTIVE: 'InActive',
  RESPONSE_DELAY_YES: 'Yes',
  RESPONSE_DELAY_NO: 'No',
  RESPONSE_DELAY_BTN_RELEASE: 'Publish',
  RESPONSE_DELAY_BTN_CANCEL: 'Cancel',
  RESPONSE_DELAY_WIDGET_TITLE: 'Wellcome',
  RESPONSE_DELAY_TYPE_HERE: 'Type here ...',
  RESPONSE_DELAY_POWERED_BY_RAYCHAT: 'Powered by Raychat',
  RESPONSE_DELAY_FORM_INPUT_TYPE_STRING: 'Text',
  RESPONSE_DELAY_FORM_INPUT_TYPE_NUMBER: 'Number',
  RESPONSE_DELAY_FORM_INPUT_TYPE_PHONE: 'Phone Number',
  RESPONSE_DELAY_FORM_INPUT_TYPE_EMAIL: 'Email',
  RESPONSE_DELAY_FORM_INPUT_TYPE_NAME: 'Name',
  RESPONSE_DELAY_TITLE_INPUT_LABEL: 'Form Title',
  RESPONSE_DELAY_TITLE_INPUT_PLACEHOLDER: 'Title ...',
  RESPONSE_DELAY_DELETE_MODAL:
    'Are you sure you want to delete the selected item?',
  RESPONSE_DELAY_DELETE_MODAL_SUBMIT_BTN: 'Confirm',
  ERROR_MESSAGE: 'Filling in the added form is essential!',
  TIME_ERROR_MESSAGE: 'Entering waiting time is essential!',
  BEFORE_RESPONSE_ERROR_MESSAGE: 'Writing pre-response message is essential!',
  AFTER_RESPONSE_ERROR_MESSAGE: 'Writing post-response message is essential!',
  DEPARTMENT_ERROR_MESSAGE: 'Selecting a department is essential!',
  TITLE_ERROR_MESSAGE: 'Writing form title is essential!',
};

export default RESPONSE_DELAY;
